import axios from "axios";
import toast from "react-hot-toast";

const baseURL = process.env.NEXT_PUBLIC_APP_WS;

export const ws = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
  validateStatus: (status) => {
    return status >= 200 && status < 300;
  }
});

ws.interceptors.request.use((config: any) => {
  const sessionString = sessionStorage.getItem("session");
  const session = sessionString ? JSON.parse(sessionString) : null;
  config.headers = config.headers ?? {};
  if (session?.token) {
    config.headers.Authorization = `Bearer ${session.token}`;
  }
  return config;
});

ws.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      if (error?.response?.data?.message === "Token expired") {
        if (typeof sessionStorage !== "undefined") sessionStorage.clear();
        window.location.href = "/e-services";
      }
      toast.error(error?.response?.data?.message || "Unauthorized!");
    }
    return Promise.reject(error);
  }
);

export default ws;
